export const CURRENCY_GET_ALL_CURRENCIES = 'CURRENCY_GET_ALL_CURRENCIES';
export const CURRENCY_GET_ALL_CURRENCIES_SUCCESS = 'CURRENCY_GET_ALL_CURRENCIES_SUCCESS';
